var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.70344 2.22656V11.7799C5.47677 11.7866 5.2501 11.8399 5.08344 11.9399L3.51677 12.8332C2.42344 13.4599 1.52344 12.9399 1.52344 11.6732V5.18656C1.52344 4.76656 1.82344 4.24656 2.19677 4.03323L5.08344 2.3799C5.2501 2.28656 5.47677 2.23323 5.70344 2.22656Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4831 4.22061V13.7739C10.2498 13.7806 10.0231 13.7406 9.84312 13.6539L6.34312 11.9006C6.16312 11.8139 5.93646 11.7739 5.70312 11.7806V2.22728C5.93646 2.22061 6.16312 2.26061 6.34312 2.34728L9.84312 4.10061C10.0231 4.18728 10.2498 4.22728 10.4831 4.22061Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.6644 4.32606V10.8127C14.6644 11.2327 14.3644 11.7527 13.991 11.9661L11.1044 13.6194C10.9377 13.7127 10.711 13.7661 10.4844 13.7727V4.21939C10.711 4.21273 10.9377 4.15939 11.1044 4.05939L12.671 3.16606C13.7644 2.53939 14.6644 3.05939 14.6644 4.32606Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2af115529fcb8e12f481fc39f380e535.svg";
export { ForwardRef as ReactComponent };